<h3 mat-dialog-title>Email Contacts</h3>

<mat-dialog-content>
    <div>
        <label>To (Default)</label><br />
        <input type="text" class="form-control" value="{{defaultContact!.name}} {{defaultContact!.email}}" disabled />
    </div>

    <div class="col-lg-12">
        <contact-email-popup (contactsChanged)="contactSelected($event)"
                             (emailsChanged)="emailsSelected($event)"
                             [contacts]="data.contacts"
                             [typedEmails]="data.typedEmails"
                             [selectedContacts]="data.selectedContacts"></contact-email-popup>
    </div>

    <div class="col-lg-12" *ngIf="data != null && data.showNotes != null && data.showNotes">
        <label style="display: block;">Notes</label>
        <textarea rows="5" cols="75" [(ngModel)]="notes"></textarea>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="epi-button" (click)="select()" style="float: right;">Send Email</button>
    <button class="epi-button" (click)="cancel()" style="float: right;">Cancel Email</button>
</mat-dialog-actions>
